import { createStyles } from '@mantine/core';

const useStyles = createStyles(() => ({
  button: {
    minWidth: 100,
  },
}));

export default useStyles;
